module.exports = __webpack_public_path__ + "img/paid-coupon.9b459a7f.svg";